<template>
    <vue3-datatable
        v-if="items.length > 0"
        ref="resultTable"
        :rows="items"
        :columns="fields"
        :pagination="false"
        :sticky-header="true"
        height="100%"
        :sortable="true"
        skin="bh-table-compact"
        row-class="routa-table-row"
        cell-class="routa-table-cell"
        @row-click="showItem"
    >
    </vue3-datatable>

</template>

<script>
import {Roles, userHelper} from '../mixins/UserMixin'
import LicenseRightsInspector from './LicenseRightsInspector'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'LicenseAdminReportTable',
    components: {LicenseRightsInspector, Vue3Datatable},
    mixins: [userHelper],
    props: {
        users: {
            type: Array,
            default: () => ([]),
        },
    },

    computed: {
        fields() {
            return [
                {field: 'username', title: this.$t('users.user_name'),  sort: true, headerClass: 'routa-table-header' },
                {field: 'name', title: this.$t('users.name'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'email', title: this.$t('users.email'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'licenseHolder', title: this.$t('users.license_holder_title'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'rights', title: this.$t('users.rights'),  sort: true, headerClass: 'routa-table-header'},
            ]
        },
        items() {
            return this.users.map((user) => ({
                id: user.id,
                lastLoginAt: user.last_login_at ?? null,
                name: `${user.last_name}, ${user.first_name}`,
                email: user.email,
                licenseHolder: user.license_holder,
                rights: this.getRoleString(user),
                username: user.username
            })).sort((a, b) => {
                return a.name < b.name ? -1 : b.name < a.name ? 1 : 0
            })
        }
    },

    methods: {
        getRoleString: function (user) {
            let result = ''
            if (user.superuser) {
                result += this.getRoleName(Roles.COMPANY_SUPER_USER)
            }
            if (user.observer) {
                if (result.length > 0) {
                    result += ', '
                }
                result += this.getRoleName(Roles.OBSERVER)
            }
            if (user.worker) {
                if (result.length > 0) {
                    result += ', '
                }
                result += this.getRoleName(Roles.WORKER)
            }
            return result;
        },
        showItem: function(item)
        {
            this.$emit('details', item)
        }
    }
}
</script>
